import { API_URLS, customAxios } from "../config";

export const getSeceruityQue = (query = "") =>
  customAxios
    .get(API_URLS.getSeceruityQue + query)
    .then((res) => res?.data)
    .catch((error) => error);

export const saveProfileDetails = (payload) =>
  customAxios
    .post(API_URLS.saveProfileDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);
export const changePasswordDetails = (payload) =>
  customAxios
    .post(API_URLS.changePasswordDetails, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getSeceruityQue,
  saveProfileDetails,
  changePasswordDetails,
};
